import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import EChallanHeroBannerV2 from "./component";

const mapStateToProps = ({
    eChallan: {
        settledChallanCount
    }
}) => ({
    settledChallanCount
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(EChallanHeroBannerV2);

